// @flow strict

export const Z_INDEX_VALUES = {
    HEADER_SECTION: 999,
};
